import React from 'react'
import {Row, Col, Input, Button,Select} from 'antd'
const {Option} = Select

class SearchGroup extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            nickName:'',
            phone:'',
            sex:''
        }
    }

    onChangeOrderDate(e) {
        this.setState({
            nickName:e.target.value
        })
        this.props.orderDateSearch(e.target.value)
    }

    onChangeResultDate(e) {
        this.setState({
            phone:e.target.value
        })
        this.props.resultDateSearch(e.target.value)
    }
    optionsChangeSex(value){
        this.setState({
            sex:value
        })
        this.props.optionsChangeSex(value)
    }
 
    searchList() {
        this.props.searchList()
    }
    reset(){
        this.setState({
            nickName:'',
            phone:'',
            sex:''
        })
        this.props.resetChange()
    }

    render() {
        return (
            <Row style={{padding: '10px 20px'}}>
                <Col offset={9} xl={5} lg={5} md={5}>
                    <label style={{marginRight: '5px'}}>性别：</label>
                    <Select
                        style={{width:'50%'}}
                        size={'small'}
                        value={this.state.sex} onChange={this.optionsChangeSex.bind(this)}
                    >
                        <Option value="1">男</Option>
                        <Option value="2">女</Option>
                        <Option value="0">未知</Option>
                    </Select>
                  
                </Col>
                <Col  xl={5} lg={5} md={5}>
                    <label style={{marginRight: '5px'}}>昵称：</label>
                    <Input style={{width:'50%'}} value={this.state.nickName} size={'small'} placeholder=""  onChange={this.onChangeOrderDate.bind(this)}/>
                </Col>
                {/* <Col xl={6} lg={6} md={6}>
                    <label style={{marginRight: '5px'}}>联系方式：</label>
                    <Input style={{width:'50%'}} size={'small'} value={this.state.phone}  onChange={this.onChangeResultDate.bind(this)}/>
                </Col> */}
                <Col xl={5} lg={5} md={5}>
                    <Button type="primary" onClick={this.searchList.bind(this)} style={{marginRight:'10px'}}>查询</Button>
                    <Button onClick={this.reset.bind(this)}>重置</Button>
                </Col>
            </Row>
        )
    }
}

export default SearchGroup